module.exports = __webpack_public_path__ + "static/media/aWOOL.37381207.png";